export interface AppointmentSlotTakenLocationState {
  knownPatientReturnTo: string;
}

const knownPatientStartPath = /^\/appointments\/[^/]+\/start\/?$/;

export const knownPatientSlotTakenState = (
  returnTo: string
): AppointmentSlotTakenLocationState => ({ knownPatientReturnTo: returnTo });

export const getKnownPatientReturnTo = (state: unknown): string | undefined => {
  if (!state || typeof state !== "object") return undefined;

  const returnTo = (state as Partial<AppointmentSlotTakenLocationState>)
    .knownPatientReturnTo;
  if (
    typeof returnTo !== "string" ||
    !returnTo.startsWith("/") ||
    returnTo.startsWith("//")
  ) {
    return undefined;
  }

  try {
    const url = new URL(returnTo, "https://scheduler.invalid");
    const isKnownPatient =
      url.searchParams.get("kp") === "1" ||
      url.searchParams.get("portal") === "1";

    return knownPatientStartPath.test(url.pathname) && isKnownPatient
      ? returnTo
      : undefined;
  } catch {
    return undefined;
  }
};
